/* eslint-disable @typescript-eslint/camelcase */
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  DateRangeInput,
  FilterButton,
  TableWrapper,
  Table,
  THead,
  Th,
  TableRow,
  Td,
  Pagination
} from '@increasecard/typed-components';
import { MdiArrowDownIcon } from '@increasecard/icons';
import { getMonthlyClearingDownloadLink, LoadingOverlay } from '@card/commonlib';
import { useMonthlyClearingsScreen } from './useMonthlyClearingsScreen';
import CardBrandIcon from '../../common/components/CardBrandIcon';
import { LoadableStatus } from '@card/types';
import { ContentCard, ContentWrapper } from '../../common/components/ContentCard';

function downloadMonthlyPayment(id: string) {
  return getMonthlyClearingDownloadLink(id).then((link) => {
    window.location.href = link;
  });
}

export function MonthlyClearingsScreen() {
  const { t } = useTranslation('clearings');
  const {
    page,
    setPage,
    monthlyClearings,
    filterFields,
    filters,
    setFilters,
    daterange,
    setDaterange
  } = useMonthlyClearingsScreen();
  return (
    <ContentCard>
      <ContentWrapper>
        <div style={{ display: 'flex', alignItems: 'flex-end' }}>
          <DateRangeInput
            dateFormat="MM/yyyy"
            datepickerProps={{ maxDetail: 'year', maxDate: new Date() }}
            id="daterange"
            label={t('common:filters:month:displayName')}
            onChange={setDaterange}
            style={{ marginRight: '8px' }}
            value={daterange}
            width="200"
          />
          <FilterButton fields={filterFields || []} onChange={setFilters} value={filters} />
        </div>
        <LoadingOverlay active={monthlyClearings.status === LoadableStatus.Fetching}>
          <TableWrapper style={{ marginTop: '16px' }}>
            <Table zebra>
              <THead>
                <TableRow>
                  <Th>{t('common:filters:clearingDate:displayName')}</Th>
                  <Th>{t('common:filters:cardBrand:displayName')}</Th>
                  <Th>{t('common:filters:processor:displayName')}</Th>
                  <Th>{t('common:filters:shops:displayName')}</Th>
                  <Th>{t('common:filters:establishment:displayName')}</Th>
                  <Th rightAligned />
                </TableRow>
              </THead>
              <tbody>
                {monthlyClearings.data?.data.map(
                  ({
                    id,
                    month,
                    year,
                    credit_card_provider,
                    provider,
                    shop_name,
                    store_number
                  }) => (
                    <TableRow key={id}>
                      <Td>
                        {month}/{year}
                      </Td>
                      <Td>
                        {credit_card_provider && (
                          <CardBrandIcon cardBrand={credit_card_provider.name} />
                        )}
                      </Td>
                      <Td>{t(`common:providers:${provider}`)}</Td>
                      <Td>{shop_name}</Td>
                      <Td>{store_number}</Td>
                      <Td rightAligned>
                        <button
                          aria-label={t('common:download')}
                          onClick={() => {
                            downloadMonthlyPayment(id);
                          }}
                          title={t('common:download')}
                        >
                          <MdiArrowDownIcon height="24" width="24" />
                        </button>
                      </Td>
                    </TableRow>
                  )
                )}
              </tbody>
            </Table>
            <div style={{ paddingTop: '16px' }}>
              <Pagination
                currentPage={page}
                onSelectPage={setPage}
                style={{ justifyContent: 'flex-end' }}
                totalPages={monthlyClearings.data ? monthlyClearings.data.total_pages : 1}
              />
            </div>
          </TableWrapper>
        </LoadingOverlay>
      </ContentWrapper>
    </ContentCard>
  );
}
